import { fetchDataWithFetch } from "./fetchBase";
import type { ThemePreference, ThemeSchedule } from '../types/ThemeType';

type RootFolderSettings = {
  mode: ThemePreference;
  currentLang: string;
  isInitialized: boolean;
  accent: 'brick' | 'sakura' | 'emerald' | 'royal';
  themeSchedule?: ThemeSchedule;
};

type RootFolder = {
  folderId: string;
  folderName: string;
  settings: RootFolderSettings;
  isActive: boolean;
};

type SharedFolders = {
  folderId: string;
  folderName: string;
  role: 'admin' | 'editor' | 'viewer';
  settings: RootFolderSettings;
};

type User = {
  id?: string | null;
  name?: string | null;
  email?: string | null;
  isActive?: boolean | null;
  lastLogin?: string | null;
  rootFolders?: RootFolder[];
  sharedFolders?: SharedFolders[];
  onboardingCompletedAt?: string | null;
};

type SignUpCredential = {
  name: string;
  email: string;
  password: string;
};

type SignUpResponse = {
  success: boolean;
  message: string;
  data: {
    id: string;
    name: string;
    email: string;
  };
};

type SignInCredential = {
  email: string;
  password: string;
};

type SignInResponse = {
  accessToken: string;
  user: User;
};

type LogoutResponse = {
  message: string;
};

export async function apiSignUp(data: SignUpCredential): Promise<SignUpResponse> {
  return fetchDataWithFetch<SignUpResponse>('/register', {
    method: 'POST',
    data,
  });
};

export async function apiSignIn(data: SignInCredential): Promise<SignInResponse> {
  return fetchDataWithFetch<SignInResponse>('/login', {
    method: 'POST',
    data,
  });
};

type CompleteOnboardingResponse = {
  onboardingCompletedAt: string;
};

export async function apiSignOut(): Promise<LogoutResponse> {
  return fetchDataWithFetch<LogoutResponse>('/logout', {
    method: 'POST',
  });
};

export async function apiCompleteOnboarding(): Promise<CompleteOnboardingResponse> {
  return fetchDataWithFetch<CompleteOnboardingResponse>('/onboarding', {
    method: 'PATCH',
  });
};